import { render, staticRenderFns } from "./VDocument.vue?vue&type=template&id=29f4c788&scoped=true&"
import script from "./VDocument.vue?vue&type=script&lang=js&"
export * from "./VDocument.vue?vue&type=script&lang=js&"
import style0 from "./VDocument.vue?vue&type=style&index=0&id=29f4c788&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@5.2.7_lodash@4.18.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f4c788",
  null
  
)

export default component.exports